<template>
  <div class="flex-row">
    <!-- MANUFACTURER OR DESCRIPTION -->
    <div class="flex-col" :style="{ flex: '0.39 1 39%' }">
      <p class="body-1 part-description base--text">
        {{ this.grouped_by == "manufacturer" ? part.description : part.mfgName }}
      </p>
    </div>

    <!-- MANUFACTURER CODE -->
    <div class="flex-col text-xs-center no-bottom-border" :style="{ flex: '0.13 1 13%' }">
      {{ part.mfgCode }}
    </div>

    <!-- PART NUMBER -->
    <div class="flex-col text-xs-center no-bottom-border pl-1" :style="{ flex: '0.31 1 31%' }">
      {{ part.partNum }}
    </div>

    <!-- YEARS COMPATIBILITY -->
    <div class="flex-col text-xs-center no-bottom-border" :style="{ flex: '0.16 1 16%' }">

      {{ this.inPage('interchange-results')  ? 'N/A' : part.years }}
    </div>

    <!-- QUANTITY -->
    <div class="flex-col text-xs-center no-bottom-border" :style="{ flex: '0 0 var(--header-quantity-width)' }">
      {{ this.inPage('interchange-results') ? 'N/A' : part.qty }}
    </div>
  </div>
</template>

<script>
import { inPage }from '@/utils'
export default {
  props: {
    part: {
      type: Object,
      required: true
    },
    grouped_by: {
      type: String,
      required: true
    }
  },
  methods: {
    inPage

  }
}
</script>